export const SUBSCRIPTION_TIERS = {
  nazionaleBase: {
    name: 'Piano Nazionale Base',
    users: 1,
    price: 9,
    priceId: 'price_1SlzuFQ6hiSfYxK54rtDRiML',
    productId: 'prod_TjSpBCg2K3rHzi',
    scope: 'national',
    dailySearchLimit: null, // unlimited
    maxMonitorings: 3,
    historyDays: 30,
    advancedAlerts: false,
    exportEnabled: false,
    prioritySupport: false,
  },
  nazionaleProfessional: {
    name: 'Piano Nazionale Professional',
    users: 3,
    price: 29,
    priceId: 'price_1SlzuQQ6hiSfYxK5BWMKFwwZ',
    productId: 'prod_TjSqTuRyU0Ubc8',
    scope: 'national',
    dailySearchLimit: null, // unlimited
    maxMonitorings: null, // unlimited
    historyDays: null, // full history
    advancedAlerts: true,
    exportEnabled: true,
    prioritySupport: true,
  },
  europaBase: {
    name: 'Piano Europa Base',
    users: 2,
    price: 19,
    priceId: 'price_1SlzubQ6hiSfYxK5I5L9Pffs',
    productId: 'prod_TjSqxKbYuJWi1A',
    scope: 'european',
    dailySearchLimit: null, // unlimited
    maxMonitorings: 5,
    historyDays: 30,
    advancedAlerts: false,
    exportEnabled: false,
    prioritySupport: false,
  },
  europaProfessional: {
    name: 'Piano Europa Professional',
    users: 5,
    price: 59,
    priceId: 'price_1SlzumQ6hiSfYxK5CABIq7p5',
    productId: 'prod_TjSqh7cGqjKcIK',
    scope: 'european',
    dailySearchLimit: null, // unlimited
    maxMonitorings: null, // unlimited
    historyDays: null, // full history
    advancedAlerts: true,
    exportEnabled: true,
    prioritySupport: true,
  },
} as const;

export type TierKey = keyof typeof SUBSCRIPTION_TIERS;

export const getTierByProductId = (productId: string): TierKey | null => {
  for (const [key, tier] of Object.entries(SUBSCRIPTION_TIERS)) {
    if (tier.productId === productId) {
      return key as TierKey;
    }
  }
  return null;
};

export const getTierByPriceId = (priceId: string): TierKey | null => {
  for (const [key, tier] of Object.entries(SUBSCRIPTION_TIERS)) {
    if (tier.priceId === priceId) {
      return key as TierKey;
    }
  }
  return null;
};

export const getDailySearchLimit = (productId: string | null): number | null => {
  if (!productId) return 3; // Free users get 3 searches
  const tierKey = getTierByProductId(productId);
  if (!tierKey) return 3;
  return SUBSCRIPTION_TIERS[tierKey].dailySearchLimit;
};

export const getMaxMonitorings = (productId: string | null): number | null => {
  if (!productId) return 1; // Free users get 1 monitoring
  const tierKey = getTierByProductId(productId);
  if (!tierKey) return 1;
  return SUBSCRIPTION_TIERS[tierKey].maxMonitorings;
};

export const getTierName = (productId: string | null): string | null => {
  if (!productId) return null;
  const tierKey = getTierByProductId(productId);
  if (!tierKey) return null;
  return SUBSCRIPTION_TIERS[tierKey].name;
};

export const isExportEnabled = (productId: string | null): boolean => {
  if (!productId) return false; // Free users cannot export
  const tierKey = getTierByProductId(productId);
  if (!tierKey) return false;
  return SUBSCRIPTION_TIERS[tierKey].exportEnabled;
};

export const isEmailAlertsEnabled = (productId: string | null): boolean => {
  if (!productId) return false; // Free users cannot use email alerts
  return true; // All paying users can use email alerts
};
